import React from 'react'

import './generic-modal.scss'

const GenericModal = props => {

    return (
        <div className={props.className? 'f-curtain-modal-generic ' + props.className : 'f-curtain-modal-generic'}>
            <div className={"f-modal-generic-container" + (props.background === "transparent" ? " bg-transparent" : "")}>
                {props.children}
            </div>
        </div>   
    )
}

export default GenericModal
